import type { SerializerOptions } from '@ember-data/legacy-compat';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type { ModelSchema } from '@ember-data/store/types';

import type { RecordAttributes, RecordData } from 'webapp-types';

import ApplicationSerializer from 'webapp/serializers/application';

import type ReminderRecord from 'webapp/models/reminder';

export default class ReminderSerializer extends ApplicationSerializer {
	// json is Raw when it comes from BE, Serialized when BufferedModel.toJSON() runs a record through normalize
	override normalize(
		typeClass: ModelSchema,
		json: RecordData.Reminder.Raw | RecordData.Reminder.Serialized,
		prop: string | undefined,
	) {
		const { schedule, ...data } = json;
		const attributes: Partial<RecordAttributes<ReminderRecord>> & { id?: string | number } = {
			...data,
		};

		if (schedule) {
			attributes.scheduleType = schedule.type;
			attributes.scheduleHourOfDay = schedule.hourOfDay;
			attributes.scheduleDayOfWeek = schedule.dayOfWeek || [];
			attributes.scheduleDayOfMonth = schedule.dayOfMonth;

			if (schedule.data) {
				attributes.objectType = schedule.data.objectType;
				attributes.objectId = schedule.data.objectId;
			}
		}

		return super.normalize(typeClass, attributes, prop);
	}

	override serialize(
		snapshot: Snapshot,
		options: SerializerOptions,
	): RecordData.Reminder.Serialized {
		const attributes = super.serialize(
			snapshot,
			options,
		) as RecordAttributes<ReminderRecord> & {
			id?: string; // only with includeId
		};

		// all attributes travel inside the schedule, none is sent when scheduleType is 0
		const json: RecordData.Reminder.Serialized =
			typeof attributes.id === 'undefined' ? {} : { id: attributes.id };

		if (attributes.scheduleType !== 0) {
			json.schedule = {
				type: attributes.scheduleType,
				hourOfDay: attributes.scheduleHourOfDay,
				dayOfWeek: attributes.scheduleDayOfWeek,
				dayOfMonth: attributes.scheduleDayOfMonth,
				data: {
					objectType: attributes.objectType,
					objectId: attributes.objectId,
				},
			};
		}

		return json;
	}
}
